import { JsonObject, JsonProperty } from "ta-json";

import Link from "../link";

@JsonObject()
export class MemberConditionResource {
    @JsonProperty("member")
    memberName: string;
}

/**
 * Condition triggered if the relation does not have ancestor of given definition id.
 */
@JsonObject()
export class NoAncestorMemberConditionResource extends MemberConditionResource {
    @JsonProperty("definition")
    definition: Link;

    constructor(init?: Partial<NoAncestorMemberConditionResource>) {
        super();
        Object.assign(this, init);
    }
}

/**
 * Condition triggered on the value of the property.
 */
@JsonObject()
export class StringMemberConditionResource extends MemberConditionResource {
    @JsonProperty("value")
    value: string;

    constructor(init?: Partial<StringMemberConditionResource>) {
        super();
        Object.assign(this, init);
    }
}

/**
 * Condition triggered on the value of the property.
 */
export class BooleanMemberConditionResource extends MemberConditionResource {
    @JsonProperty("value")
    value: boolean;

    constructor(init?: Partial<BooleanMemberConditionResource>) {
        super();
        Object.assign(this, init);
    }
}

/**
 * Condition triggered on ancestor id of the relation.
 */
@JsonObject()
export class RelationMemberConditionResource extends MemberConditionResource {
    @JsonProperty("value")
    value: Link;

    constructor(init?: Partial<RelationMemberConditionResource>) {
        super();
        Object.assign(this, init);
    }
}
